import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { TypeOperationModificative } from '../texte.model';
import { ListesGeneriquesService } from '@app/_global/listes-generiques.service';

@Injectable({providedIn: 'root'})
@Pipe({name: 'operationType'})
export class OperationTypePipe implements PipeTransform {

	constructor(private listesGeneriquesService: ListesGeneriquesService) {}

	transform(tot_code: TypeOperationModificative): string {
		return this.listesGeneriquesService.getDefinitionOperation(tot_code)?.tot_libelle ?? '?';
	}
}
